import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../App.module.css';
import FooterLinks from '../components/layout/FooterLinks';
import BurgerHint from '../components/layout/BurgerHint';
import ThreeBenefits from '../components/layout/ThreeBenefits';

const SplashPage = ({ theme }) => {
  return (
    <div className={`${styles.container} ${theme === 'dark' ? styles.darkBackground : styles.lightBackground}`}>
      <div className={styles.staticContentBox}>
        <h1 className={styles.pageHeading}>
          🌼 Welcome to{' '}
          <span style={{ fontFamily: 'Arial, sans-serif', fontSize: '2rem' }}>
            <span style={{ color: '#6b7280' }}>d</span>
            <span style={{ color: '#1d4ed8', fontWeight: 'bold' }}>AI</span>
            <span style={{ color: '#6b7280' }}>sy</span>
          </span>
        </h1>

        {/* Burger Tip */}
        <BurgerHint />

        {/* Simple Navigation Links */}
        <div style={{ marginTop: '2rem', textAlign: 'left' }}>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
          <li style={{ marginBottom: '0.75rem' }}>
             💬 <Link to="/chat">Chat</Link> - Chat with <strong>dAIsy</strong>!
            </li>
            <li style={{ marginBottom: '0.75rem' }}>
              🌱 <Link to="/about">About</Link> - What makes <strong>dAIsy</strong> so unique?
            </li>
            <li style={{ marginBottom: '0.75rem' }}>
              🔒 <Link to="/privacy">Privacy</Link> - Your data stays private.
            </li>
            <li style={{ marginBottom: '0.75rem' }}>
              ❓ <Link to="/faq">FAQ</Link> - Find quick answers.
            </li>
            <li style={{ marginBottom: '0.75rem' }}>
              🔐 <Link to="/login">Log In</Link> - Already a member? Welcome back.
            </li>
            <li style={{ marginBottom: '0.75rem' }}>
              🧠 <Link to="/register">Register</Link> - Start your journey with <strong>dAIsy</strong>.
            </li>
            <li style={{ marginBottom: '0.75rem' }}>
              💬 <Link to="/help">Help</Link> - Get personal support.
            </li>
            <li style={{ marginBottom: '0.75rem' }}>
              📞 <Link to="/contact">Contact</Link> - Reach out if you need us.
            </li>
            <li style={{ marginBottom: '0.75rem' }}>
              📜 <Link to="/terms">Terms</Link> - The simple legal stuff.
            </li>
            <li style={{ marginBottom: '0.75rem' }}>
              👤 <Link to="/founder">Founder</Link> - The story behind <strong>dAIsy</strong>.
            </li>
          </ul>

          {/* ✨ Three Benefits Section */}
          <ThreeBenefits />
        </div>

        {/* Footer */}
        <FooterLinks />
      </div>
    </div>
  );
};

export default SplashPage;
